import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'v1',
    loadChildren: () =>
      import('./components/v1/v1.module').then((m) => m.V1Module),
  },
  {
    path: 'v2',
    loadChildren: () =>
      import('./components/v2/v2.module').then((m) => m.V2Module),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
